import * as endpoints from 'pkg/api/endpoints/auto';
import type { InitManageDisputesResponse } from 'pkg/api/payment_providers/adyen';
import * as sdk from 'pkg/core/sdk';

export async function initManageDisputes(
	organizationId: number,
	paymentConfigId: number
): Promise<[boolean, InitManageDisputesResponse]> {
	const req = await sdk.post(
		endpoints.Payments.InitiateManageDisputes(organizationId, paymentConfigId)
	);

	if (!req.ok) {
		return [false, null];
	}

	const resp = await req.json();

	return [true, resp];
}
